import { isLoadingUserSelector } from 'store/selectors/userSelectors';
import { useTypedSelector } from 'hooks/useTypedSelector';
import { UserLoaderStyled } from 'components/UserLoader/styled';
import { LogoLargeIcn } from 'utils/icons';

const UserLoader = () => {
  const isLoadingUser: boolean = useTypedSelector(isLoadingUserSelector);

  return (
    <UserLoaderStyled isLoading={isLoadingUser}>
      <LogoLargeIcn />
    </UserLoaderStyled>
  );
};

export default UserLoader;
